import type { FC } from "react";
import React, { memo } from "react";
import type { TyreType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import TyreDetails from "./TyreDetails";

const WheelDetails: FC<{ tyres: TyreType[] | undefined }> = ({ tyres }) => {
    if (!tyres) return null;
    return (
        <>
            {tyres.map((tyre) => (
                <TyreDetails key={tyre.id} tyre={tyre} />
            ))}
        </>
    );
};

export default memo(WheelDetails);
